/**
 * Review Model Configuration (Frontend)
 *
 * This file provides the same model configuration as the backend,
 * ensuring consistency between frontend dropdowns and backend validation.
 *
 * IMPORTANT: This must stay in sync with lambda/util/review-models.ts
 */

/**
 * Enum of available review models
 */
export const ReviewModel = {
  CLAUDE_3_5_SONNET_V2: 'CLAUDE_3_5_SONNET_V2',
  CLAUDE_3_HAIKU: 'CLAUDE_3_HAIKU',
  CLAUDE_SONNET_4_5: 'CLAUDE_SONNET_4_5',
  CLAUDE_HAIKU_4_5: 'CLAUDE_HAIKU_4_5',
}

/**
 * Available models for conversation review
 * These match the backend REVIEW_MODELS configuration
 */
export const REVIEW_MODELS = [
  {
    id: ReviewModel.CLAUDE_3_5_SONNET_V2,
    name: 'Claude 3.5 Sonnet v2',
    costDisplay: '$3/$15 per M tokens',
  },
  {
    id: ReviewModel.CLAUDE_3_HAIKU,
    name: 'Claude 3 Haiku',
    costDisplay: '$0.25/$1.25 per M tokens',
  },
  {
    id: ReviewModel.CLAUDE_SONNET_4_5,
    name: 'Claude Sonnet 4.5',
    costDisplay: '$3/$15 per M tokens',
  },
  {
    id: ReviewModel.CLAUDE_HAIKU_4_5,
    name: 'Claude Haiku 4.5',
    costDisplay: '$1/$5 per M tokens',
  },
]

/**
 * Get model display name by ID
 */
export function getModelName(modelId) {
  const model = REVIEW_MODELS.find((m) => m.id === modelId)
  return model?.name || modelId
}
